import { supabase } from './supabase'
import { verifyTimeResponse } from './jobTimeContract.mjs'

export class JobTimeRejectedError extends Error {}

export async function jobTimeRequest(domain, scope, command = null, key = null) {
  if (!['time', 'cost'].includes(domain) || (domain === 'cost' && !scope.owner)) throw new Error('Owner costing access required.')
  const { data: { session } } = await supabase.auth.getSession()
  if (!session || session.user?.id !== scope.actorId) throw new Error('Sign in again to continue.')
  const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 20000)
  try {
    const response = await fetch(`/.netlify/functions/job-${domain}`, { method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
      body: JSON.stringify({ workshop_id: scope.workshopId, job_id: scope.jobId, operation: command ? 'write' : 'read', ...(command ? { key, command } : {}) }) })
    if (!/^application\/json\b/i.test(response.headers.get('content-type') || '')) throw new Error()
    const text = await response.text()
    if (new Blob([text]).size > 4 * 1024 * 1024) throw new Error()
    const result = JSON.parse(text)
    if (!response.ok && result.recording_outcome === 'rejected_without_write') throw new JobTimeRejectedError('The request was rejected without changes. Check the interval, permissions or source evidence before trying again.')
    if (!response.ok || !result.data) throw new Error()
    if (domain === 'time') verifyTimeResponse(result.data, { ...scope, writing: Boolean(command) })
    else if (!command && (result.data.version !== 'job-cost-v1' || result.data.workshop_id !== scope.workshopId || result.data.job_id !== scope.jobId)) throw new Error()
    return result.data
  } catch (e) { if (e instanceof JobTimeRejectedError) throw e; throw new Error('The request could not be confirmed. Retry the same request safely, or refresh to inspect the current records.') }
  finally { clearTimeout(timeout) }
}

export function minorAmount(value) {
  if (!/^\d{1,8}(\.\d{1,2})?$/.test(value)) throw new Error('Use a non-negative amount with at most two decimal places.')
  const [whole, fraction = ''] = value.split('.')
  const minor = Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
  if (minor > 2147483647) throw new Error('Amount exceeds the supported limit.')
  return minor
}
